import React from 'react'

// App-level safety net: a render error in any page must never white-screen the
// whole console (nav included). It degrades to a small card instead, so the rest
// of the shell stays usable and the user can navigate away.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    // Surface it for debugging; never swallow silently.
    console.error('[ErrorBoundary]', error, info?.componentStack)
  }

  reset = () => this.setState({ error: null })

  render() {
    if (!this.state.error) return this.props.children
    return (
      <div style={{
        margin: '32px auto', maxWidth: 560, background: '#fff', border: '1px solid #ECEBE3',
        borderRadius: 16, padding: '28px 30px', fontFamily: 'Nunito, system-ui, sans-serif',
        boxShadow: '0 10px 26px rgba(46,58,69,.08)',
      }}>
        <p style={{ fontSize: 18, fontWeight: 800, margin: '0 0 6px', color: '#2E3A45' }}>
          This section hit a snag
        </p>
        <p style={{ fontSize: 14, color: '#7C8794', margin: '0 0 16px', lineHeight: 1.55 }}>
          Something in this view failed to render, but the rest of the app is fine. Try again, or switch pages from the menu.
        </p>
        <button onClick={this.reset} style={{
          border: 'none', borderRadius: 10, padding: '10px 18px', background: '#4E9AC4',
          color: '#fff', fontWeight: 800, fontFamily: 'inherit', fontSize: 13, cursor: 'pointer',
        }}>Try again</button>
        {this.state.error?.message && (
          <pre style={{
            marginTop: 16, fontSize: 11.5, color: '#AEB6BD', whiteSpace: 'pre-wrap',
            fontFamily: 'ui-monospace, monospace', maxHeight: 120, overflow: 'auto',
          }}>{String(this.state.error.message)}</pre>
        )}
      </div>
    )
  }
}
